import { isSettingsPath } from '@feature/settings/settings-navigation'
import { ConnectionStatus } from '@shared/components/feedback/ConnectionStatus'
import { usePageTitle } from '@shared/hooks/usePageTitle'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { Link, Outlet, useLocation } from 'react-router'
import { Header } from './Header'
import { Sidebar } from './Sidebar'

export function AppLayout() {
  const location = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  usePageTitle()

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_hsl(var(--primary)/0.08),_transparent_32%),linear-gradient(180deg,hsl(var(--background)),hsl(var(--muted)/0.35))]">
      <a
        href="#conteudo"
        className="sr-only z-[60] rounded-lg bg-primary text-base font-semibold text-primary-foreground focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:px-4 focus:py-3"
      >
        Ir para o conteúdo
      </a>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="lg:pl-64">
        <Header onMenuClick={() => setSidebarOpen(true)} />

        <main
          id="conteudo"
          tabIndex={-1}
          className="mx-auto min-h-[calc(100vh-4rem)] w-full max-w-[1680px] px-4 py-5 md:px-6 md:py-6 lg:px-8 lg:py-8 2xl:px-10 focus:outline-none"
        >
          {isSettingsPath(location.pathname) && (
            <Link
              to="/settings"
              className="mb-5 inline-flex items-center gap-2 rounded-lg text-sm font-medium text-muted-foreground transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-4"
            >
              <ArrowLeft className="h-4 w-4" aria-hidden="true" />
              Todas as configurações
            </Link>
          )}
          <ConnectionStatus />
          <Outlet />
        </main>
      </div>
    </div>
  )
}
